import { qsa } from "@fluorescent/dom";
import { section } from "@/neon";

import { backgroundVideoHandler } from "@/lib/a11y";

const selectors = {
  video: ".mosaic-grid__item-video",
};

section("mosaic-grid", {
  onLoad() {
    const videos = qsa(selectors.video, this.container);
    this.videoHandlers = [];

    if (videos.length) {
      videos.forEach(video => {
        this.videoHandlers.push(backgroundVideoHandler(video.parentNode));
      });
    }
  },

  onUnload() {
    this.videoHandlers.forEach(handler => handler());
  },
});
